"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ScrollableStack = _interopRequireDefault(require("@commerce-ui/core2/ScrollableStack"));
var _Container = _interopRequireDefault(require("@commerce-ui/core2/Container"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Theme = require("@commerce-ui/core2/Theme");
var _useHover = _interopRequireDefault(require("@commerce-ui/core2/useHover"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var defaultProps = {
  titleAs: "h3"
};
var CardsSlider = function CardsSlider(props) {
  var children = props.children,
    title = props.title,
    _props$titleAs = props.titleAs,
    titleAs = _props$titleAs === void 0 ? defaultProps.titleAs : _props$titleAs,
    itemsVisible = props.itemsVisible,
    itemsGap = props.itemsGap,
    buttonArrowLeft = props.buttonArrowLeft,
    buttonArrowRight = props.buttonArrowRight;
  var theme = (0, _Theme.useTheme)();
  var gap = itemsGap ? itemsGap : theme.space.gridGap;
  var margin = theme.space.containerMargin;
  var rootRef = (0, _react.useRef)(null);
  var rootHovered = (0, _useHover["default"])(rootRef);
  return __jsx(_Box["default"], {
    _ref: rootRef
  }, __jsx(_Container["default"], null, __jsx(_Box["default"], {
    as: titleAs,
    sx: {
      font: "label",
      mb: "s8"
    }
  }, title)), __jsx(_Container["default"], {
    margin: [0, null, "containerMargin"]
  }, __jsx(_ScrollableStack["default"], {
    sx: {
      width: "100%",
      $itemsVisible: itemsVisible ? itemsVisible : [1.5, null, 3, null, 4],
      $gap: gap,
      $innerMargin: [margin[0], null, 0] // TODO: in commerce-ui update we'll allow for ["containerMargin", null, 0] syntax.
    },
    previousButton: function previousButton(_ref) {
      var isAtStart = _ref.isAtStart;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowLeft, {
          sx: {
            opacity: !rootHovered || isAtStart ? 0 : 1,
            transition: "opacity .15s",
            pointerEvents: !rootHovered || isAtStart ? "none" : "default"
          }
        }),
        offset: -22
      };
    },
    nextButton: function nextButton(_ref2) {
      var isAtEnd = _ref2.isAtEnd;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowRight, {
          sx: {
            opacity: !rootHovered || isAtEnd ? 0 : 1,
            transition: "opacity .15s",
            pointerEvents: !rootHovered || isAtEnd ? "none" : "default"
          }
        }),
        offset: -22
      };
    }
  }, children)));
};
var _default = CardsSlider;
exports["default"] = _default;